<div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">{{ 'USERS.TITLE' | translate }}</h4>
        <div class="d-flex align-items-center gap-2">
            <app-input [(ngModel)]="filters.q"
                       (ngModelChange)="updateSearch()"
                       placeholder="{{ 'common.filter.field_search_records' | translate }}"
                       groupIconPosition="right"
                       groupIcon="ti-search"
                       slot="search"
                       containerStyles="mb-0"/>
            <button class="btn btn-dark btn-sm" (click)="openCreateModal()">
                <i class="ti ti-plus"></i>
                {{ 'USERS.NEW_USER' | translate }}
            </button>
        </div>
    </div>

    <div class="card-body p-0">
        <app-table [tableData]="items">
            <!-- Header da Tabela -->
            <ng-template app-table-header>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="COMMON.LABEL.USER"
                    sortField="name"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="COMMON.LABEL.ROLE"
                    sortField="role"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="COMMON.LABEL.STATUS"
                    sortField="status"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col" class="pe-4 text-end">{{ 'COMMON.LABEL.ACTIONS' | translate }}</th>
            </ng-template>
            <ng-template app-table-body let-user>
                <td class="ps-4">
                    <div class="d-flex align-items-center gap-2">
                        <div class="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                             [style.width.px]="32"
                             [style.height.px]="32"
                             [style.background-color]="getAvatarColor(user)">
                            {{ getUserInitials(user.firstName + ' ' + user.lastName) }}
                        </div>
                        <div>
                            <div class="fw-medium">{{ user.firstName }} {{ user.lastName }}</div>
                            <small class="text-muted">{{ user.email }}</small>
                        </div>
                    </div>
                </td>
                <td>
                    <span [class]="getRoleBadgeClass(user.profile)">
                        {{ getRoleLabel(user.profile) }}
                    </span>
                </td>
                <td>
                    @if (user.status === 'ACTIVE') {
                        <span class="badge bg-dark text-white">
                            {{ 'COMMON.STATUS.ACTIVE' | translate }}
                        </span>
                    } @else {
                        <span class="badge bg-light text-dark border">
                            {{ 'COMMON.STATUS.INACTIVE' | translate }}
                        </span>
                    }
                </td>
                <td class="pe-4 text-end">
                    <div class="btn-group btn-group-sm">
                        <button class="btn btn-light" title="Editar" (click)="openEditModal(user)">
                            <i class="ti ti-edit"></i>
                        </button>
                        <button class="btn btn-light" title="Alterar Senha" (click)="openChangePasswordModal(user)">
                            <i class="ti ti-lock"></i>
                        </button>
                        <button class="btn btn-light" title="Excluir" (click)="deleteUser(user)">
                            <i class="ti ti-trash"></i>
                        </button>
                    </div>
                </td>
            </ng-template>
        </app-table>

        <!-- Loading overlay -->
        <app-loading-overlay [show]="isLoading"/>

        <!-- Alert Empty Table -->
        <app-empty-alert-message [show]="!isLoading && items.length === 0" containerClass="m-2"/>

        <app-pagination
                [show]="items.length > 0"
                [itemsAmount]="pagination.itemsAmount"
                [itemsPerPage]="filters.size"
                [currentPage]="currentPage"
                (onChangeItemsPerPage)="changeItemsPerPage($event)"
                (onPaginate)="paginate($event)"/>
    </div>
</div>

